import { api } from '../../DefaultService';
import { ICigamCreateProps, ICigamProps, ICigamUpdateParams } from './types';

const ENDPOINT = '/v1/integrations/cigam';

export const createCigamIntegrationAsync = async (data: ICigamCreateProps) => {
  return await api
    .post(`${ENDPOINT}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getCigamIntegrationByIdAsync = async (
  id: number,
): Promise<ICigamProps> => {
  return await api
    .get<ICigamProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateCigamIntegrationAsync = async ({
  id,
  data,
}: ICigamUpdateParams) => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteCigamIntegrationAsync = async (id: number) => {
  return await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
